var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.0102 6.165L8.4002 5.555C8.2552 5.43 8.1702 5.245 8.1652 5.04C8.1552 4.815 8.2452 4.59 8.4102 4.425L9.0102 3.825C9.5302 3.305 9.7252 2.805 9.5602 2.41C9.4002 2.02 8.9052 1.805 8.1752 1.805H2.9502V1.375C2.9502 1.17 2.7802 1 2.5752 1C2.3702 1 2.2002 1.17 2.2002 1.375V10.625C2.2002 10.83 2.3702 11 2.5752 11C2.7802 11 2.9502 10.83 2.9502 10.625V8.185H8.1752C8.8952 8.185 9.3802 7.965 9.5452 7.57C9.7102 7.175 9.5202 6.68 9.0102 6.165Z",
    fill: "#AAAAAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d2cb68788279617e1a5d9a5b73d3e9c8.svg";
export { ForwardRef as ReactComponent };